import { render, staticRenderFns } from "./SaleOrderPdf.vue?vue&type=template&id=90f5a504&"
import script from "./SaleOrderPdf.vue?vue&type=script&lang=js&"
export * from "./SaleOrderPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports